
import request from "../../request";
import ImageIcon from '@mui/icons-material/Image';
import SearchItem from "../../components/SearchItem";

async function fetchProducts() {
   const res = await request.get("/api/general/products", {
      params: {
         fields: [ '_id', 'name', 'description' ],
         ignore_pagination: true
      }
   });

   return res.data.products;
}

export default function SearchProduct(props) {

   return <SearchItem
      {...props}
      fetchData={fetchProducts}
      transformOption={product => ({ ...product, label: product.name })}
      renderOption={
         (props, product) => <li {...props} className="grid grid-cols-[auto,1fr] gap-2 overflow-hidden p-2 border-b-[1px] cursor-pointer">
            <div className="flex items-center text-gray-400 text-4xl">
               <ImageIcon fontSize="inherit" />
            </div>
            <div className="flex flex-col justify-center text-sm overflow-hidden">
               <div className="font-bold">
                  {product.name}
               </div>
               <div className="text-gray-500 truncate text-xs">
                  {product.description}
               </div>
            </div>
         </li>
      }
      emptyStateMessage="No agents found in the system"
      dataNotFetchedMessage="Agents not fetched"
   />
}

export { fetchProducts };